import { addToBasketV2 } from "./addToBasketV2";
import { trackEcommerceEvent } from "../../../utils";
import { attributes, ecommerceEvents } from "../../../scripts/constants";

const initAddToBasketV2Bulk = (onAdd?: () => void) => {

    const button = document.querySelector(".button[data-add-to-basket-v2-bulk]")

    if (button == null) return;
    button.addEventListener("click", () => {
        const products = []
        var trackingData = []
        let totalPrice: number
        totalPrice = 0
        Array.from(document.body.querySelectorAll(".product-view-item .product-detail-view__select"))
            .map((b) => {
                return {
                    element: b,
                    eventId: parseInt(b.getAttribute("data-event-id")),
                    productId: parseInt(b.getAttribute("data-product-id")),
                    price: parseFloat(b.getAttribute("data-price")),
                    zoneId: parseFloat(b.getAttribute("data-area-id")),
                    quantity: parseInt((b as HTMLSelectElement).value)
                };
            })
            .forEach((product) => {
                const { element, eventId, productId, zoneId, price, quantity } = product;
                const eventPageId = parseInt(document.querySelector<HTMLInputElement>("#eventPageId").value);

                if (quantity > 0) {
                    products.push({
                        eventId,
                        productId,
                        quantity,
                        zoneId,
                        productPrice: price,
                        cmsContentId: eventPageId
                    })                

                    trackingData.push({
                        ...JSON.parse(element.getAttribute(attributes.itemTracking)),
                        ...{ quantity: quantity }
                    });

                    totalPrice += price * quantity;
                }

                element.setAttribute("data-bound", "");

            })
        const addPromise = addToBasketV2(button as HTMLElement, products);
        if (!!onAdd) {
            addPromise.then(onAdd);
        }
           
        trackEcommerceEvent({
            event: ecommerceEvents.add_to_cart,
            ecommerce: {
                currencyCode: "GBP",
                value: totalPrice,
                items: trackingData
            }
        });        
    });

};

export { initAddToBasketV2Bulk };
